import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        
        <p className="intro">
          Know Your Ante? Trivia! does not collect, store, or share personal information.
        </p>
        
        <p>
          The app works offline. Any game data is stored locally on your device and is not transmitted to us or to third parties.
        </p>
        
        <div className="contact-section">
          <p>
            <strong>Contact:</strong> <a href="mailto:kyacontact@knowyourante.com">kyacontact@knowyourante.com</a>
          </p>
          <p>
            <strong>Effective date:</strong> 2/9/2026
          </p>
        </div>
        
        <div className="back-link">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
